import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use('Vuex')

 const store = new Vuex.Store({
   plugins: [createPersistedState({
        storage: window.sessionStorage,
    })],
  state: {
    user: [],
    story: [],
    profile: '',
    pageLength: 6,
    loginState: false,
    token: '',
    reauthToken: '',
    filter: 'all'
    },
  mutations: {
  login (state, user) {
    state.user = user.user
    state.loginState = true
    state.token = user.token
    state.reauthToken = user.reauthToken
  },
    logout (state) {
    state.user = [],
    state.loginState = false;
    state.token = '';
    state.reauthToken = '';
  },
    story (state, story) {
    state.story = story
  },
    profile (state, profile) {
    state.profile = profile
  },
    profileSas (state, profileSas) {
    state.profileSas = profileSas
    console.log('logout mutation says state.profileSas is: ', state.profileSas)
  },
    profileUpdate (state, user) {
    state.user = user;
  },
    filter (state, filter) {
    state.filter = filter;
  },
},
  actions: {
    login({commit}, user) {
      commit('login', user)
    },
    logout({commit}) {
      commit('logout')
    },
    profileUpdate({commit}, user) {
      commit('profileUpdate', user)
    },
    setStory({commit}, story) {
      commit('story', story)
    },
    setProfile({commit}, profile) {
      commit('profile', profile)
    },
    setProfileSas({commit}, profileSas) {
      commit('profileSas', profileSas)
    },
    setFilter({commit}, filter) {
      commit('filter', filter)
    },
},
    getters: {
        getUser: state => state.user,
        getuserID: state => state.s4u.UserID,
        getauthCircle: state => state.s4u.PrimaryCircle,
        getStory: state => state.story,
        getProfile: state => state.profile,
        getProfileSas: state => state.profileSas,
        getToken: state => state.token,
        getReauthToken: state => state.reauthToken,
        getFilter: state => state.filter
    }

})
Vue.prototype.$store = store;

export default store;